export const Attachment = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M3.81245 9.78791C3.37655 7.39065 4.83263 5.02754 7.21244 4.50468C13.3728 3.15122 17.9112 3.20886 23.7131 4.49784C26.0905 5.02602 27.5424 7.38899 27.1067 9.78505L24.5357 23.9248C24.197 25.7872 22.7779 27.2829 20.9236 27.6635C16.3508 28.6022 14.6048 28.5415 10.0579 27.6388C8.17324 27.2647 6.71666 25.7596 6.37292 23.8692L3.81245 9.78791Z"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
      />
      <rect
        className="bounty_prime_color_svg"
        x="12.9761"
        y="10.2148"
        width="4.71803"
        height="8.19448"
        rx="0.944549"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
      />
    </svg>
  );
};
export const Front = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.05083 11.7631C4.618 12.2557 5.23948 12.4279 5.67403 12.4279H25.2774C25.9341 12.4279 26.4594 12.2073 26.8768 11.8543C28.8983 10.1443 26.6239 7.21065 24.0193 6.73487C17.4866 5.54158 11.2279 5.98737 6.87861 6.76108C4.31989 7.21625 2.08863 10.059 4.05083 11.7631Z"
        fill="#FBABA5"
      />
      <path
        d="M18.5137 15.5673C18.1704 15.5885 17.8366 15.5888 17.5002 15.569C16.164 15.4902 15.297 14.1084 15.5656 12.6933L15.6991 11.9898C15.9059 10.9002 16.7215 10.006 17.7469 9.95086C17.9112 9.94202 18.0686 9.94271 18.2323 9.95263C19.279 10.016 20.115 10.9205 20.3244 12.0237L20.4511 12.6915C20.7196 14.1061 19.8521 15.4848 18.5137 15.5673Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M23.1969 14.5427C23.1429 14.5435 23.089 14.5437 23.0352 14.5432C22.3975 14.5376 21.8838 14.2084 21.5524 13.7052C21.2181 13.1974 21.0763 12.5193 21.2015 11.8551L21.2107 11.8064C21.4036 10.7829 22.1664 9.94039 23.0942 9.94449C24.0403 9.94866 24.8181 10.8135 25.014 11.8529C25.1382 12.512 24.9983 13.1888 24.6667 13.6975C24.338 14.2019 23.8286 14.5332 23.1969 14.5427Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.60001 14.5427C7.54596 14.5435 7.49206 14.5437 7.43824 14.5432C6.80061 14.5376 6.28687 14.2084 5.95548 13.7052C5.62117 13.1974 5.47941 12.5193 5.60458 11.8551L5.61376 11.8064C5.80663 10.7829 6.56946 9.94039 7.49727 9.94449C8.44339 9.94866 9.22118 10.8135 9.41706 11.8529C9.54126 12.512 9.40138 13.1888 9.06982 13.6975C8.74107 14.2019 8.23167 14.5332 7.60001 14.5427Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M13.1157 15.5678C12.7724 15.589 12.4387 15.5893 12.1022 15.5695C10.7661 15.4907 9.89905 14.1089 10.1676 12.6938L10.3012 11.9903C10.508 10.9007 11.3235 10.0065 12.349 9.95135C12.5133 9.94251 12.6706 9.9432 12.8344 9.95311C13.8811 10.0165 14.717 10.921 14.9264 12.0242L15.0532 12.692C15.3217 14.1066 14.4541 15.4852 13.1157 15.5678Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M21.2693 23.9673C17.214 23.636 13.2698 23.7293 9.94281 23.997C6.1633 24.3011 1.88053 18.9504 5.67225 18.9504L25.2641 18.9504C25.3716 18.9638 25.4754 18.983 25.5757 19.0075C29.1686 19.8873 24.956 24.2685 21.2693 23.9673Z"
        fill="#FBABA5"
      />
      <path
        d="M12.105 15.8223C12.4483 15.8011 12.782 15.8008 13.1185 15.8207C14.4547 15.8994 15.3217 17.2813 15.0531 18.6964L14.9195 19.3999C14.7127 20.4895 13.8972 21.3836 12.8717 21.4388C12.7074 21.4476 12.5501 21.4469 12.3863 21.437C11.3396 21.3737 10.5037 20.4691 10.2943 19.3659L10.1675 18.6982C9.89904 17.2836 10.7666 15.9049 12.105 15.8223Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.42196 16.8464C7.47601 16.8456 7.52991 16.8454 7.58373 16.8459C8.22136 16.8515 8.7351 17.1807 9.06649 17.684C9.40081 18.1917 9.54256 18.8699 9.41739 19.5341L9.40821 19.5828C9.21534 20.6063 8.45251 21.4488 7.52471 21.4447C6.57859 21.4405 5.80079 20.5757 5.60491 19.5362C5.48072 18.8772 5.6206 18.2004 5.95215 17.6916C6.2809 17.1872 6.7903 16.856 7.42196 16.8464Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M23.0186 16.8464C23.0727 16.8456 23.1266 16.8454 23.1804 16.8459C23.818 16.8515 24.3318 17.1807 24.6632 17.684C24.9975 18.1917 25.1392 18.8699 25.0141 19.5341L25.0049 19.5828C24.812 20.6063 24.0492 21.4488 23.1214 21.4447C22.1753 21.4405 21.3975 20.5757 21.2016 19.5362C21.0774 18.8772 21.2173 18.2004 21.5488 17.6916C21.8776 17.1872 22.387 16.856 23.0186 16.8464Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M17.5039 15.8223C17.8472 15.8011 18.1809 15.8008 18.5174 15.8207C19.8536 15.8994 20.7206 17.2813 20.452 18.6964L20.3185 19.3999C20.1117 20.4895 19.2961 21.3836 18.2706 21.4388C18.1063 21.4476 17.949 21.4469 17.7852 21.437C16.7385 21.3737 15.9026 20.4691 15.6932 19.3659L15.5665 18.6982C15.298 17.2836 16.1655 15.9049 17.5039 15.8223Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Top = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 18.9477C1.3834 4.89239 11.9203 1.00965 17.0158 0.825195C22.2958 0.874067 33.2846 4.56699 35 18.9477H29.9506C28.5211 14.8178 23.9328 6.59953 17.0158 6.76554C13.4651 7.55498 6.19763 11.0966 5.5336 18.9477H0Z"
        fill="#FBABA5"
      />
      <path
        d="M15.0627 3.66345C13.8613 3.89934 12.8192 4.24694 11.7124 4.7671C10.4059 5.38112 9.76801 7.06258 10.2649 8.39079L11.0259 10.4254C11.3952 11.4125 12.3104 11.9861 13.3329 11.7986C14.1841 11.6424 14.7454 11.4498 15.5574 11.0549C16.5541 10.5701 17.2381 9.46183 17.2933 8.32121L17.4041 6.0323C17.4775 4.51547 16.4221 3.39652 15.0627 3.66345Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.64667 8.31612C6.97912 8.8011 6.40073 9.32894 5.82748 9.96787C4.88098 11.0228 4.76582 12.8832 5.50217 14.0063L6.45597 15.461C7.01787 16.318 7.9522 16.5713 8.7723 15.9842C9.18885 15.686 9.49914 15.3992 9.86466 14.983C10.602 14.1433 10.8901 12.7681 10.6319 11.6175L10.2074 9.72575C9.87327 8.23677 8.71045 7.54329 7.64667 8.31612Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M3.85035 16.0502C3.67205 16.42 3.51626 16.7934 3.3755 17.1863C2.88639 18.5516 3.6037 20.3949 4.81319 21.0896L4.95804 21.1728C5.83844 21.6784 6.78668 21.4779 7.24468 20.5689C7.38334 20.2936 7.49041 20.0328 7.59257 19.7254C7.93721 18.6884 7.63809 17.3142 6.93455 16.3557L6.83985 16.2267C5.88387 14.9243 4.45744 14.7912 3.85035 16.0502Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M19.8704 3.66345C21.0718 3.89934 22.1139 4.24694 23.2207 4.7671C24.5272 5.38112 25.1651 7.06258 24.6682 8.39079L23.9072 10.4254C23.5379 11.4125 22.6227 11.9861 21.6002 11.7986C20.749 11.6424 20.1877 11.4498 19.3757 11.0549C18.379 10.5701 17.695 9.46183 17.6398 8.32121L17.529 6.0323C17.4556 4.51547 18.511 3.39652 19.8704 3.66345Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M27.2864 8.31637C27.954 8.80134 28.5324 9.32918 29.1056 9.96811C30.0521 11.0231 30.1673 12.8835 29.4309 14.0065L28.4771 15.4613C27.9152 16.3183 26.9809 16.5715 26.1608 15.9845C25.7443 15.6863 25.434 15.3994 25.0684 14.9832C24.3311 14.1436 24.043 12.7683 24.3012 11.6178L24.7257 9.72599C25.0598 8.23701 26.2227 7.54354 27.2864 8.31637Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M31.0828 16.0502C31.2611 16.42 31.4168 16.7934 31.5576 17.1863C32.0467 18.5516 31.3294 20.3949 30.1199 21.0896L29.9751 21.1728C29.0947 21.6784 28.1464 21.4779 27.6884 20.5689C27.5498 20.2936 27.4427 20.0328 27.3405 19.7254C26.9959 18.6884 27.295 17.3142 27.9986 16.3557L28.0933 16.2267C29.0492 14.9243 30.4757 14.7912 31.0828 16.0502Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Bottom = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 5.39017C33.6166 19.4455 23.0797 23.3282 17.9842 23.5127C12.7042 23.4638 1.71542 19.7709 5.39902e-06 5.39016L5.04941 5.39016C6.47892 9.52006 11.0672 17.7384 17.9842 17.5724C21.5349 16.7829 28.8024 13.2413 29.4664 5.39017L35 5.39017Z"
        fill="#FBABA5"
      />
      <path
        d="M19.9366 20.6744C21.1379 20.4386 22.1801 20.091 23.2868 19.5708C24.5933 18.9568 25.2313 17.2753 24.7344 15.9471L23.9733 13.9125C23.6041 12.9254 22.6889 12.3517 21.6664 12.5393C20.8152 12.6955 20.2539 12.8881 19.4419 13.283C18.4451 13.7678 17.7611 14.8761 17.7059 16.0167L17.5952 18.3056C17.5218 19.8224 18.5772 20.9414 19.9366 20.6744Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M27.3536 16.0218C28.0211 15.5368 28.5995 15.009 29.1728 14.37C30.1193 13.3151 30.2344 11.4547 29.4981 10.3316L28.5443 8.87686C27.9824 8.01985 27.048 7.76659 26.2279 8.35367C25.8114 8.65187 25.5011 8.93871 25.1356 9.35493C24.3982 10.1945 24.1102 11.5698 24.3684 12.7204L24.7929 14.6121C25.127 16.1011 26.2898 16.7946 27.3536 16.0218Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M31.1492 8.28771C31.3275 7.91793 31.4833 7.54448 31.624 7.15156C32.1131 5.78627 31.3958 3.94302 30.1863 3.24833L30.0415 3.16514C29.1611 2.65947 28.2128 2.86003 27.7548 3.76904C27.6162 4.04425 27.5091 4.30512 27.4069 4.61251C27.0623 5.64951 27.3614 7.02366 28.065 7.98214L28.1597 8.11115C29.1156 9.41354 30.5421 9.54674 31.1492 8.28771Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M15.1318 20.6744C13.9304 20.4386 12.8883 20.091 11.7815 19.5708C10.475 18.9568 9.8371 17.2753 10.334 15.9471L11.095 13.9125C11.4643 12.9254 12.3795 12.3517 13.402 12.5393C14.2532 12.6955 14.8145 12.8881 15.6265 13.283C16.6232 13.7678 17.3072 14.8761 17.3624 16.0167L17.4732 18.3056C17.5466 19.8224 16.4912 20.9414 15.1318 20.6744Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.71478 16.0218C7.04723 15.5368 6.46885 15.009 5.8956 14.37C4.94909 13.3151 4.83393 11.4547 5.57029 10.3316L6.52409 8.87686C7.08599 8.01985 8.02032 7.76659 8.84041 8.35367C9.25697 8.65187 9.56726 8.93871 9.93278 9.35493C10.6701 10.1945 10.9582 11.5698 10.7 12.7204L10.2755 14.6121C9.94138 16.1011 8.77856 16.7946 7.71478 16.0218Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M3.9192 8.28771C3.7409 7.91793 3.58511 7.54448 3.44435 7.15156C2.95524 5.78626 3.67255 3.94302 4.88204 3.24833L5.02689 3.16514C5.90729 2.65947 6.85553 2.86003 7.31353 3.76904C7.45219 4.04425 7.55926 4.30512 7.66142 4.61251C8.00606 5.64951 7.70694 7.02366 7.00339 7.98214L6.9087 8.11115C5.95272 9.41354 4.52629 9.54674 3.9192 8.28771Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Lower = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 41 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.03728 7.63273C3.06376 5.93098 4.37687 5.3787 5.22917 5.3787L35.821 5.3787C37.4269 5.57867 38.5135 6.6043 39.2319 7.95612C40.9676 11.2225 37.1941 14.087 33.5245 13.6215C24.0825 12.4236 14.6624 12.8602 7.83861 13.658C4.03922 14.1023 0.0615019 10.9082 2.03728 7.63273Z"
        fill="#FBABA5"
      />
      <path
        d="M13.7447 0.497875C15.4056 0.230871 16.8086 0.238041 18.3895 0.493455C19.7483 0.712983 20.6023 2.08024 20.3368 3.47901L19.6293 7.20648C19.4261 8.27728 18.609 9.13335 17.5567 9.30664C16.424 9.49315 15.7394 9.48265 14.6117 9.29678C13.5395 9.12003 12.7016 8.25747 12.4957 7.17255L11.795 3.48078C11.5294 2.08177 12.3847 0.7165 13.7447 0.497875Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M6.64632 2.02201C7.66543 1.89092 8.58202 1.89301 9.56072 2.0184C10.9102 2.19128 11.7645 3.56073 11.5005 4.96186L11.0607 7.29543C10.858 8.37126 10.0437 9.23954 8.998 9.38015C8.35903 9.46608 7.87917 9.46143 7.24336 9.37364C6.17704 9.22641 5.34201 8.35099 5.13666 7.26127L4.70368 4.96365C4.43966 3.56261 5.29528 2.1958 6.64632 2.02201Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M31.0018 2.02201C32.0209 1.89092 32.9375 1.89301 33.9162 2.0184C35.2657 2.19128 36.12 3.56073 35.8559 4.96186L35.4162 7.29543C35.2134 8.37126 34.3992 9.23954 33.3535 9.38015C32.7145 9.46608 32.2346 9.46143 31.5988 9.37364C30.5325 9.22641 29.6975 8.35099 29.4921 7.26127L29.0591 4.96365C28.7951 3.56261 29.6507 2.1958 31.0018 2.02201Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M22.1697 0.497874C23.8307 0.230871 25.2336 0.238041 26.8145 0.493455C28.1734 0.712983 29.0274 2.08024 28.7619 3.47901L28.0544 7.20648C27.8512 8.27728 27.034 9.13335 25.9817 9.30664C24.8491 9.49315 24.1644 9.48265 23.0368 9.29678C21.9645 9.12003 21.1266 8.25747 20.9207 7.17255L20.22 3.48078C19.9545 2.08177 20.8097 0.7165 22.1697 0.497874Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Upper = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 35 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.93062 7.13865C1.85709 8.76356 3.26207 9.2627 4.12523 9.2627H30.8103C32.3389 9.2627 33.3446 8.38447 33.9865 7.2288C35.2721 4.91411 33.269 2.3746 30.679 1.82504C20.4102 -0.353796 10.4605 0.558075 4.21624 1.84571C1.6709 2.37059 -0.356647 4.88095 0.93062 7.13865Z"
        fill="#FBABA5"
      />
      <path
        d="M22.5874 13.5462C21.4103 13.7079 20.3689 13.7048 19.2416 13.5501C17.8865 13.3642 17.0304 11.9929 17.2965 10.5906L17.7994 7.94142C18.0032 6.86732 18.8185 6.00416 19.8668 5.85332C20.6289 5.74366 21.1684 5.7496 21.9267 5.86068C22.9954 6.01722 23.8321 6.88746 24.0386 7.97535L24.5346 10.5888C24.8008 11.9912 23.9438 13.3598 22.5874 13.5462Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M28.7775 12.2052C28.1437 12.2666 27.548 12.2664 26.9337 12.2079C25.5914 12.0803 24.7329 10.7059 24.9979 9.29954L25.2683 7.86456C25.4722 6.78262 26.2858 5.90155 27.3231 5.79963C27.6828 5.76428 27.9952 5.76628 28.3533 5.80352C29.4115 5.91357 30.2459 6.80308 30.4524 7.89872L30.716 9.29776C30.981 10.7038 30.1216 12.0751 28.7775 12.2052Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.54626 12.2052C6.91251 12.2666 6.31683 12.2664 5.70247 12.2079C4.3602 12.0803 3.5017 10.7059 3.76673 9.29954L4.03715 7.86456C4.24104 6.78262 5.05463 5.90155 6.09185 5.79963C6.45161 5.76428 6.76401 5.76628 7.12206 5.80352C8.18034 5.91357 9.01469 6.80308 9.22116 7.89872L9.4848 9.29776C9.74977 10.7038 8.8904 12.0751 7.54626 12.2052Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M15.2393 13.5464C14.0622 13.7081 13.0207 13.7051 11.8934 13.5503C10.5384 13.3644 9.68224 11.9931 9.9484 10.5908L10.4512 7.94166C10.6551 6.86757 11.4703 6.00441 12.5187 5.85357C13.2808 5.74391 13.8203 5.74984 14.5786 5.86092C15.6472 6.01747 16.484 6.8877 16.6904 7.97559L17.1865 10.5891C17.4527 11.9914 16.5957 13.36 15.2393 13.5464Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Right = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.68837 6.05938C20.5508 4.30263 23.0186 7.08194 22.7851 8.91251V21.1957C22.7851 21.7166 22.7405 22.2492 22.5115 22.7171C20.7994 26.2157 14.3681 25.8313 9.18326 24.7061C6.65387 24.1572 4.99976 21.8254 4.99976 19.2371V11.7634C4.99976 8.96923 6.93003 6.50547 9.68837 6.05938Z"
        fill="#FBABA5"
      />
      <path
        d="M24.2193 12.6659C24.4707 14.0563 23.6274 15.4086 22.304 15.5432C21.6761 15.6071 21.0865 15.6068 20.4779 15.546C19.1565 15.4139 18.314 14.0585 18.5655 12.6677L18.8606 11.0359C19.0566 9.95223 19.8618 9.0629 20.8944 8.96193C21.2274 8.92937 21.5202 8.9312 21.8516 8.96557C22.906 9.07494 23.7324 9.97344 23.9309 11.0714L24.2193 12.6659Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M12.7063 12.7731C12.9572 14.1708 12.107 15.5262 10.8037 15.5842C10.5963 15.5934 10.392 15.5937 10.1875 15.5853C8.88673 15.5317 8.03697 14.1733 8.28804 12.7749L8.39512 12.1786C8.59245 11.0796 9.39876 10.1648 10.4062 10.1479C10.4538 10.1471 10.5013 10.1473 10.5489 10.1484C11.5785 10.1724 12.406 11.1008 12.6059 12.2143L12.7063 12.7731Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M18.2467 12.7224C18.5013 14.1206 17.6504 15.4799 16.3319 15.5716C15.9598 15.5975 15.5995 15.5978 15.2354 15.5734C13.9192 15.4854 13.069 14.123 13.3237 12.7242L13.4985 11.7639C13.6971 10.6729 14.5045 9.7713 15.5261 9.7142C15.6884 9.70513 15.8438 9.70581 16.0054 9.71593C17.0491 9.78127 17.8774 10.694 18.0787 11.7992L18.2467 12.7224Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M24.2193 18.4571C24.4707 17.0667 23.6274 15.7145 22.304 15.5799C21.6761 15.516 21.0865 15.5162 20.4779 15.5771C19.1565 15.7091 18.314 17.0646 18.5655 18.4553L18.8606 20.0872C19.0566 21.1708 19.8618 22.0601 20.8944 22.1611C21.2274 22.1937 21.5202 22.1918 21.8516 22.1575C22.906 22.0481 23.7324 21.1496 23.9309 20.0517L24.2193 18.4571Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M12.7063 18.3499C12.9572 16.9523 12.107 15.5968 10.8037 15.5389C10.5963 15.5296 10.392 15.5293 10.1875 15.5378C8.88673 15.5913 8.03697 16.9498 8.28804 18.3481L8.39512 18.9445C8.59245 20.0434 9.39876 20.9582 10.4062 20.9751C10.4538 20.9759 10.5013 20.9758 10.5489 20.9747C11.5785 20.9506 12.406 20.0223 12.6059 18.9088L12.7063 18.3499Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M18.247 18.4006C18.5016 17.0024 17.6506 15.6432 16.3321 15.5514C15.96 15.5256 15.5997 15.5253 15.2356 15.5496C13.9194 15.6376 13.0692 17 13.3239 18.3988L13.4987 19.3591C13.6974 20.4502 14.5047 21.3518 15.5264 21.4088C15.6886 21.4179 15.844 21.4172 16.0057 21.4071C17.0493 21.3418 17.8777 20.4291 18.0789 19.3239L18.247 18.4006Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Left = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8104 6.05938C9.94801 4.30263 7.48021 7.08194 7.71371 8.91251V21.1957C7.71371 21.7166 7.75833 22.2492 7.98728 22.7171C9.69937 26.2157 16.1307 25.8313 21.3155 24.7061C23.8449 24.1572 25.499 21.8254 25.499 19.2371V11.7634C25.499 8.96923 23.5687 6.50547 20.8104 6.05938Z"
        fill="#FBABA5"
      />
      <path
        d="M8.19522 15.5432C8.82319 15.6071 9.41279 15.6068 10.0214 15.546C11.3428 15.4139 12.1853 14.0585 11.9338 12.6677L11.6387 11.0359C11.4427 9.95223 10.6375 9.0629 9.60485 8.96193C9.2719 8.92937 8.97905 8.9312 8.64771 8.96557C7.5933 9.07494 6.7669 9.97344 6.56834 11.0714L6.27997 12.6659C6.02852 14.0563 6.8719 15.4086 8.19522 15.5432Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M19.6954 15.5842C19.9027 15.5934 20.107 15.5937 20.3115 15.5853C21.6123 15.5317 22.4621 14.1733 22.211 12.7749L22.1039 12.1786C21.9066 11.0796 21.1003 10.1648 20.0929 10.1479C20.0452 10.1471 19.9977 10.1473 19.9501 10.1484C18.9205 10.1724 18.093 11.1008 17.8931 12.2143L17.7927 12.7731C17.5418 14.1708 18.392 15.5262 19.6954 15.5842Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M14.1669 15.5716C14.539 15.5975 14.8993 15.5978 15.2634 15.5734C16.5796 15.4854 17.4298 14.123 17.1751 12.7242L17.0003 11.7639C16.8016 10.6729 15.9943 9.7713 14.9727 9.7142C14.8104 9.70513 14.655 9.70581 14.4934 9.71593C13.4497 9.78127 12.6213 10.694 12.4201 11.7992L12.252 12.7224C11.9975 14.1206 12.8484 15.4799 14.1669 15.5716Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M8.19547 15.5799C8.82343 15.516 9.41304 15.5162 10.0216 15.5771C11.343 15.7091 12.1855 17.0646 11.934 18.4553L11.6389 20.0872C11.4429 21.1708 10.6377 22.0601 9.6051 22.1611C9.27215 22.1937 8.97929 22.1918 8.64795 22.1575C7.59354 22.0481 6.76715 21.1496 6.56859 20.0517L6.28022 18.4571C6.02877 17.0667 6.87215 15.7145 8.19547 15.5799Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M19.6956 15.5389C19.903 15.5296 20.1072 15.5293 20.3118 15.5378C21.6125 15.5913 22.4623 16.9498 22.2112 18.3481L22.1041 18.9445C21.9068 20.0434 21.1005 20.9582 20.0931 20.9751C20.0454 20.9759 19.998 20.9758 19.9504 20.9747C18.9207 20.9506 18.0933 20.0223 17.8933 18.9088L17.793 18.3499C17.542 16.9523 18.3923 15.5968 19.6956 15.5389Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M14.1669 15.5514C14.539 15.5256 14.8993 15.5253 15.2634 15.5496C16.5796 15.6376 17.4298 17 17.1751 18.3988L17.0003 19.3591C16.8016 20.4502 15.9943 21.3518 14.9727 21.4088C14.8104 21.4179 14.655 21.4172 14.4933 21.4071C13.4497 21.3418 12.6213 20.4291 12.4201 19.3239L12.252 18.4006C11.9975 17.0024 12.8484 15.6432 14.1669 15.5514Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const SuperImpose = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M15.9682 6.64536C11.924 5.40865 9.96558 5.15206 6.80274 5.84436C4.67147 6.31086 3.39452 8.45852 3.7549 10.6103L4.88382 17.3509C5.17497 19.0894 6.47425 20.5382 8.19748 20.9089C8.82979 21.0449 9.31427 21.0933 10.0563 21.0479"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
        strokeLinecap="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M12.5797 16.1899C11.8803 14.1233 12.8037 11.8025 14.8565 11.0635C17.2174 10.2137 19.2632 9.89591 21.6508 9.95772C23.8306 10.0141 25.4353 11.9287 25.4232 14.1092L25.385 21.0022C25.3753 22.7367 24.3506 24.3446 22.7167 24.9266C21.1984 25.4673 20.2111 25.6103 18.6145 25.5758C16.8523 25.5376 15.3357 24.3333 14.7707 22.6637L12.5797 16.1899Z"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
      />
    </svg>
  );
};
export const BackStep = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M27.5001 10.4249V19.5749C27.5001 21.4499 25.4626 22.6249 23.8376 21.6874L19.8751 19.3999L15.9126 17.1124L15.3 16.7624V13.2374L15.9126 12.8874L19.8751 10.5999L23.8376 8.31241C25.4626 7.37491 27.5001 8.54991 27.5001 10.4249Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        d="M15.3 10.4249V19.5749C15.3 21.4499 13.2626 22.6249 11.6501 21.6874L7.67507 19.3999L3.71255 17.1124C2.10005 16.1749 2.10005 13.8249 3.71255 12.8874L7.67507 10.5999L11.6501 8.31241C13.2626 7.37491 15.3 8.54991 15.3 10.4249Z"
        fill="#898A8D"
      />
    </svg>
  );
};
export const ForwardStep = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M2.5 10.4249V19.5749C2.5 21.4499 4.53749 22.6249 6.16249 21.6874L10.125 19.3999L14.0875 17.1124L14.7 16.7624V13.2374L14.0875 12.8874L10.125 10.5999L6.16249 8.31241C4.53749 7.37491 2.5 8.54991 2.5 10.4249Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.7 10.4249V19.5749C14.7 21.4499 16.7374 22.6249 18.3499 21.6874L22.3249 19.3999L26.2874 17.1124C27.8999 16.1749 27.8999 13.8249 26.2874 12.8874L22.3249 10.5999L18.3499 8.31241C16.7374 7.37491 14.7 8.54991 14.7 10.4249Z"
        fill="#898A8D"
      />
    </svg>
  );
};
export const SkipFirst = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M20.24 7.22006V16.7901C20.24 18.7501 18.11 19.9801 16.41 19.0001L12.26 16.6101L8.10996 14.2101C6.40996 13.2301 6.40996 10.7801 8.10996 9.80006L12.26 7.40006L16.41 5.01006C18.11 4.03006 20.24 5.25006 20.24 7.22006Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        d="M3.76001 18.9301C3.35001 18.9301 3.01001 18.5901 3.01001 18.1801V5.82007C3.01001 5.41007 3.35001 5.07007 3.76001 5.07007C4.17001 5.07007 4.51001 5.41007 4.51001 5.82007V18.1801C4.51001 18.5901 4.17001 18.9301 3.76001 18.9301Z"
        fill="#898A8D"
      />
    </svg>
  );
};
export const SkipLast = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M3.76004 7.22006V16.7901C3.76004 18.7501 5.89004 19.9801 7.59004 19.0001L11.74 16.6101L15.89 14.2101C17.59 13.2301 17.59 10.7801 15.89 9.80006L11.74 7.40006L7.59004 5.01006C5.89004 4.03006 3.76004 5.25006 3.76004 7.22006Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        d="M20.24 18.9301C20.65 18.9301 20.99 18.5901 20.99 18.1801V5.82007C20.99 5.41007 20.65 5.07007 20.24 5.07007C19.83 5.07007 19.49 5.41007 19.49 5.82007V18.1801C19.49 18.5901 19.83 18.9301 20.24 18.9301Z"
        fill="#898A8D"
      />
    </svg>
  );
};
export const Play = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9501 36.6666C29.1549 36.6666 36.6168 29.2047 36.6168 19.9999C36.6168 10.7952 29.1549 3.33325 19.9501 3.33325C10.7454 3.33325 3.28345 10.7952 3.28345 19.9999C3.28345 29.2047 10.7454 36.6666 19.9501 36.6666Z"
        fill="#00C7B1"
      />
      <path
        d="M24.9501 17.05L20.1168 14.2667C18.9168 13.5667 17.4668 13.5667 16.2668 14.2667C15.0668 14.9667 14.3501 16.2 14.3501 17.6V23.1834C14.3501 24.5667 15.0668 25.8167 16.2668 26.5167C16.8668 26.8667 17.5334 27.0334 18.1834 27.0334C18.8501 27.0334 19.5001 26.8667 20.1001 26.5167L24.9334 23.7334C26.1334 23.0334 26.8501 21.8 26.8501 20.4C26.8834 19 26.1668 17.75 24.9501 17.05Z"
        fill="white"
      />
    </svg>
  );
};
export const Pause = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9499 36.6667C29.1546 36.6667 36.6165 29.2048 36.6165 20C36.6165 10.7953 29.1546 3.33337 19.9499 3.33337C10.7451 3.33337 3.2832 10.7953 3.2832 20C3.2832 29.2048 10.7451 36.6667 19.9499 36.6667Z"
        fill="#00C7B1"
      />
      <path
        d="M19.1 24.74V15.26C19.1 14.36 18.72 14 17.76 14H15.34C14.38 14 14 14.36 14 15.26V24.74C14 25.64 14.38 26 15.34 26H17.76C18.72 26 19.1 25.64 19.1 24.74Z"
        fill="white"
      />
      <path
        d="M26.0004 24.74V15.26C26.0004 14.36 25.6204 14 24.6604 14H22.2404C21.2871 14 20.9004 14.36 20.9004 15.26V24.74C20.9004 25.64 21.2804 26 22.2404 26H24.6604C25.6204 26 26.0004 25.64 26.0004 24.74Z"
        fill="white"
      />
    </svg>
  );
};
export const Shrink = () => {
  return (
    <svg
      width="48"
      height="51"
      viewBox="0 0 48 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.2422 20.6623C37.2422 20.8844 37.1541 21.0972 36.997 21.2546L28.1036 20.6262C27.5442 20.0667 27.2299 19.3084 27.2299 18.5179L27.2299 12.3249C27.2299 12.026 27.3896 11.7495 27.6487 11.5999L27.649 11.5998C27.9078 11.4503 28.2273 11.4503 28.4861 11.5998L28.4863 11.5999C28.7455 11.7495 28.9052 12.026 28.9052 12.3249L28.9052 18.5179C28.9052 18.8648 29.0431 19.197 29.288 19.4418C29.5329 19.6867 29.865 19.8247 30.212 19.8247L36.4049 19.8247C36.6268 19.8247 36.8399 19.9129 36.9971 20.0701C37.1539 20.2269 37.2422 20.4399 37.2422 20.6623L37.2422 20.6623ZM36.997 21.2546L28.1036 20.6263C28.6631 21.1856 29.4214 21.4999 30.212 21.4999L36.4049 21.4999C36.6267 21.4999 36.8397 21.4118 36.997 21.2546Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0676 39.5123C27.8455 39.5123 27.6326 39.4242 27.4752 39.2671L28.1036 30.3738C28.6631 29.8144 29.4215 29.5001 30.212 29.5001L36.4049 29.5001C36.7039 29.5001 36.9804 29.6597 37.13 29.9189L37.1301 29.9191C37.2796 30.1779 37.2796 30.4974 37.1301 30.7563L37.13 30.7565C36.9804 31.0157 36.7039 31.1753 36.4049 31.1753L30.212 31.1753C29.865 31.1753 29.5329 31.3133 29.288 31.5582C29.0432 31.803 28.9052 32.1351 28.9052 32.4821L28.9052 38.6751C28.9052 38.8969 28.817 39.11 28.6597 39.2673C28.503 39.424 28.29 39.5123 28.0676 39.5123L28.0676 39.5123ZM27.4752 39.2671L28.1036 30.3738C27.5442 30.9332 27.2299 31.6915 27.2299 32.4821L27.2299 38.6751C27.2299 38.8968 27.318 39.1098 27.4752 39.2671Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1746 11.4877C19.3967 11.4877 19.6095 11.5758 19.767 11.7329L19.1386 20.6262C18.5791 21.1856 17.8207 21.4999 17.0302 21.4999H10.8373C10.5383 21.4999 10.2618 21.3403 10.1122 21.0811L10.1121 21.0809C9.96264 20.8221 9.96263 20.5026 10.1121 20.2437L10.1122 20.2435C10.2618 19.9843 10.5383 19.8247 10.8373 19.8247H17.0302C17.3772 19.8247 17.7093 19.6867 17.9542 19.4418C18.199 19.197 18.337 18.8649 18.337 18.5179V12.3249C18.337 12.1031 18.4252 11.89 18.5825 11.7327C18.7392 11.576 18.9522 11.4877 19.1746 11.4877L19.1746 11.4877ZM19.767 11.7329L19.1386 20.6262C19.698 20.0668 20.0122 19.3085 20.0122 18.5179V12.3249C20.0122 12.1032 19.9241 11.8902 19.767 11.7329Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 30.3375C10 30.1154 10.0881 29.9025 10.2452 29.7451L19.1386 30.3735C19.698 30.933 20.0123 31.6913 20.0123 32.4819L20.0123 38.6748C20.0123 38.9738 19.8526 39.2503 19.5934 39.3999L19.5932 39.4C19.3344 39.5494 19.0149 39.5495 18.7561 39.4L18.7559 39.3999C18.4967 39.2503 18.337 38.9738 18.337 38.6748L18.337 32.4819C18.337 32.1349 18.1991 31.8028 17.9542 31.5579C17.7093 31.3131 17.3772 31.1751 17.0302 31.1751L10.8373 31.1751C10.6154 31.1751 10.4023 31.0869 10.2451 30.9296C10.0883 30.7729 10 30.5599 10 30.3375L10 30.3375ZM10.2452 29.7451L19.1385 30.3735C18.5791 29.8141 17.8208 29.4998 17.0302 29.4998L10.8373 29.4998C10.6155 29.4998 10.4025 29.5879 10.2452 29.7451Z"
        fill="black"
      />
    </svg>
  );
};
export const Expand = () => {
  return (
    <svg
      width="48"
      height="51"
      viewBox="0 0 48 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.23 12.3248C27.23 12.1027 27.3181 11.8899 27.4752 11.7325L36.3685 12.3609C36.928 12.9204 37.2422 13.6787 37.2422 14.4693L37.2422 20.6622C37.2422 20.9611 37.0826 21.2377 36.8234 21.3872L36.8232 21.3874C36.5644 21.5368 36.2449 21.5368 35.986 21.3873L35.9858 21.3872C35.7266 21.2377 35.567 20.9611 35.567 20.6622L35.567 14.4693C35.567 14.1223 35.429 13.7902 35.1841 13.5453C34.9393 13.3004 34.6072 13.1624 34.2602 13.1624L28.0672 13.1624C27.8454 13.1624 27.6323 13.0743 27.475 12.917C27.3183 12.7603 27.23 12.5473 27.23 12.3248L27.23 12.3248ZM27.4752 11.7325L36.3685 12.3609C35.8091 11.8015 35.0508 11.4872 34.2602 11.4872L28.0673 11.4872C27.8455 11.4872 27.6325 11.5753 27.4752 11.7325Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.4046 29.5006C36.6267 29.5006 36.8395 29.5886 36.997 29.7458L36.3685 38.6391C35.8091 39.1985 35.0507 39.5128 34.2602 39.5128H28.0672C27.7683 39.5128 27.4918 39.3532 27.3422 39.094L27.3421 39.0938C27.1926 38.8349 27.1926 38.5155 27.3421 38.2566L27.3422 38.2564C27.4918 37.9972 27.7683 37.8376 28.0672 37.8376H34.2602C34.6072 37.8376 34.9393 37.6996 35.1842 37.4547C35.429 37.2098 35.567 36.8778 35.567 36.5307V30.3378C35.567 30.116 35.6552 29.9029 35.8124 29.7456C35.9692 29.5889 36.1822 29.5006 36.4046 29.5005L36.4046 29.5006ZM36.997 29.7458L36.3686 38.6391C36.928 38.0797 37.2422 37.3213 37.2422 36.5308V30.3378C37.2422 30.1161 37.1541 29.903 36.997 29.7458Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8376 21.4994C10.6155 21.4994 10.4027 21.4114 10.2452 21.2542L10.8737 12.3609C11.4331 11.8015 12.1915 11.4872 12.982 11.4872L19.175 11.4872C19.4739 11.4872 19.7504 11.6468 19.9 11.906C20.0494 12.1648 20.0496 12.4845 19.9001 12.7434C19.7505 13.0026 19.4739 13.1624 19.175 13.1624L12.982 13.1624C12.635 13.1624 12.3029 13.3004 12.058 13.5453C11.8132 13.7902 11.6752 14.1222 11.6752 14.4693L11.6752 20.6622C11.6752 20.884 11.587 21.0971 11.4297 21.2544C11.273 21.4111 11.06 21.4994 10.8376 21.4994ZM10.2452 21.2542L10.8737 12.3609C10.3143 12.9203 9.99996 13.6787 9.99996 14.4692L9.99996 20.6622C9.99996 20.8839 10.0881 21.097 10.2452 21.2542Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0122 38.674C20.0122 38.8961 19.9241 39.1089 19.767 39.2664L10.8736 38.6379C10.3142 38.0785 9.99994 37.3201 9.99994 36.5296L9.99994 30.3366C9.99994 30.0377 10.1596 29.7612 10.4188 29.6116L10.419 29.6115C10.6778 29.462 10.9973 29.462 11.2561 29.6115L11.2564 29.6116C11.5155 29.7612 11.6752 30.0377 11.6752 30.3366L11.6752 36.5296C11.6752 36.8766 11.8132 37.2087 12.0581 37.4536C12.3029 37.6984 12.635 37.8364 12.982 37.8364L19.175 37.8364C19.3968 37.8364 19.6099 37.9246 19.7671 38.0819C19.9239 38.2386 20.0122 38.4516 20.0122 38.674L20.0122 38.674ZM19.767 39.2664L10.8737 38.638C11.4331 39.1974 12.1914 39.5116 12.982 39.5116L19.1749 39.5116C19.3967 39.5116 19.6097 39.4235 19.767 39.2664Z"
        fill="black"
      />
    </svg>
  );
};
export const ZoomIn = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M10.25 15.125H19"
        stroke="#6C6C6C"
        strokeWidth="2.9085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.625 19.5V10.75"
        stroke="#6C6C6C"
        strokeWidth="2.9085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.375 26.75C20.9334 26.75 26.25 21.4334 26.25 14.875C26.25 8.31662 20.9334 3 14.375 3C7.81662 3 2.5 8.31662 2.5 14.875C2.5 21.4334 7.81662 26.75 14.375 26.75Z"
        stroke="#6C6C6C"
        strokeWidth="2.0775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M27.5 28L25 25.5"
        stroke="#6C6C6C"
        strokeWidth="2.0775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ZoomOut = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M9.75 15.125H19"
        stroke="#6C6C6C"
        strokeWidth="2.52739"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.375 26.75C20.9334 26.75 26.25 21.4334 26.25 14.875C26.25 8.31662 20.9334 3 14.375 3C7.81662 3 2.5 8.31662 2.5 14.875C2.5 21.4334 7.81662 26.75 14.375 26.75Z"
        stroke="#6C6C6C"
        strokeWidth="2.0775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M27.5 28L25 25.5"
        stroke="#6C6C6C"
        strokeWidth="2.0775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Split = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 28 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M14.1301 2L14.1301 32"
        stroke="#6C6C6C"
        strokeWidth="2.075"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.13 2.9624H9.88003C6.6527 2.9624 4.12367 3.60151 2.42766 5.29753C0.731641 6.99354 0.0925293 9.52257 0.0925293 12.7499V20.2499C0.0925293 23.4772 0.731641 26.0063 2.42766 27.7023C4.12367 29.3983 6.6527 30.0374 9.88003 30.0374H13.13V27.9624H9.88003C6.85736 27.9624 5.01139 27.3515 3.8949 26.235C2.77842 25.1185 2.16753 23.2726 2.16753 20.2499V12.7499C2.16753 9.72723 2.77842 7.88126 3.8949 6.76478C5.01139 5.64829 6.85736 5.0374 9.88003 5.0374H13.13V2.9624Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.505 2.9624C14.932 2.9624 14.4675 3.42691 14.4675 3.9999C14.4675 4.5729 14.932 5.0374 15.505 5.0374H17.38C17.9909 5.0374 18.5573 5.06239 19.0817 5.11239C19.6521 5.16678 20.1586 4.74846 20.213 4.17805C20.2674 3.60764 19.849 3.10115 19.2786 3.04676C18.6795 2.98964 18.0467 2.9624 17.38 2.9624H15.505ZM23.114 4.06047C22.6034 3.80047 21.9787 4.00364 21.7187 4.51425C21.4587 5.02487 21.6618 5.64957 22.1725 5.90956C23.0893 6.37639 23.7535 7.04067 24.2204 7.95748C24.4804 8.4681 25.1051 8.67126 25.6157 8.41127C26.1263 8.15128 26.3295 7.52657 26.0695 7.01596C25.4036 5.70831 24.4216 4.7263 23.114 4.06047ZM27.0832 10.8513C27.0288 10.2809 26.5223 9.86257 25.9519 9.91696C25.3815 9.97134 24.9632 10.4778 25.0175 11.0483C25.0675 11.5727 25.0925 12.139 25.0925 12.7499V14.6249C25.0925 15.1979 25.557 15.6624 26.13 15.6624C26.703 15.6624 27.1675 15.1979 27.1675 14.6249V12.7499C27.1675 12.0832 27.1403 11.4504 27.0832 10.8513ZM27.1675 18.3749C27.1675 17.8019 26.703 17.3374 26.13 17.3374C25.557 17.3374 25.0925 17.8019 25.0925 18.3749V20.2499C25.0925 20.8608 25.0675 21.4271 25.0175 21.9516C24.9632 22.522 25.3815 23.0285 25.9519 23.0828C26.5223 23.1372 27.0288 22.7189 27.0832 22.1485C27.1403 21.5494 27.1675 20.9166 27.1675 20.2499V18.3749ZM26.0695 25.9838C26.3295 25.4732 26.1263 24.8485 25.6157 24.5885C25.1051 24.3285 24.4804 24.5317 24.2204 25.0423C23.7535 25.9591 23.0893 26.6234 22.1725 27.0902C21.6618 27.3502 21.4587 27.9749 21.7187 28.4856C21.9787 28.9962 22.6034 29.1993 23.114 28.9393C24.4216 28.2735 25.4036 27.2915 26.0695 25.9838ZM19.2786 29.953C19.849 29.8987 20.2674 29.3922 20.213 28.8218C20.1586 28.2513 19.6521 27.833 19.0817 27.8874C18.5573 27.9374 17.9909 27.9624 17.38 27.9624H15.505C14.932 27.9624 14.4675 28.4269 14.4675 28.9999C14.4675 29.5729 14.932 30.0374 15.505 30.0374H17.38C18.0467 30.0374 18.6795 30.0102 19.2786 29.953Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};
export const Ipr = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 29 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6846 3.02927L20.6899 1.46704L22.9648 1.96714L22.9605 3.03511C22.9589 3.66357 22.4481 4.17173 21.8196 4.17011C21.1912 4.1685 20.683 3.65773 20.6846 3.02927ZM21.8162 5.49997C22.4447 5.50158 22.9529 6.01235 22.9512 6.64081L22.942 10.2465C22.9404 10.875 22.4296 11.3831 21.8011 11.3815C21.1727 11.3799 20.6645 10.8691 20.6661 10.2407L20.6754 6.63498C20.677 6.00652 21.1878 5.49835 21.8162 5.49997ZM21.7977 12.7114C22.4262 12.713 22.9344 13.2238 22.9327 13.8522L22.9235 17.4579C22.9219 18.0864 22.4111 18.5946 21.7826 18.5929C21.1542 18.5913 20.646 18.0806 20.6476 17.4521L20.6569 13.8464C20.6585 13.2179 21.1693 12.7098 21.7977 12.7114ZM21.7792 19.9228C22.4077 19.9244 22.9159 20.4352 22.9142 21.0636L22.905 24.6693C22.9034 25.2978 22.3926 25.806 21.7641 25.8044C21.1357 25.8027 20.6275 25.292 20.6291 24.6635L20.6384 21.0578C20.64 20.4293 21.1508 19.9212 21.7792 19.9228ZM21.7607 27.1342C22.3892 27.1358 22.8974 27.6466 22.8957 28.2751L22.8957 29.2409L20.6199 30.2063L20.6199 28.2692C20.6215 27.6408 21.1323 27.1326 21.7607 27.1342Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3276 1.41699C15.2946 0.65458 10.7877 0.846831 5.09425 2.10265C1.80076 2.8291 -0.155698 6.09124 0.431117 9.33115L3.27442 25.0295C3.73931 27.5963 5.71084 29.6495 8.27693 30.1609C10.8149 30.6667 12.6508 30.9539 14.516 30.9666C16.2696 30.9785 18.002 30.7478 20.3276 30.2828V27.9193C17.8214 28.4355 16.161 28.6611 14.5316 28.65C12.8957 28.6389 11.2375 28.3891 8.72625 27.8886C7.10671 27.5659 5.84328 26.2634 5.54474 24.6151L2.70144 8.9167C2.32014 6.8115 3.59754 4.80468 5.58942 4.36532C11.1331 3.14254 15.4318 2.97892 20.3276 3.76111V1.41699ZM23.3276 25.154C23.3752 24.9988 23.414 24.8396 23.4435 24.677L26.2986 8.91351C26.6798 6.80861 25.4055 4.80109 23.4149 4.35711C23.3858 4.35061 23.3567 4.34414 23.3276 4.3377V1.96747C23.5224 2.00893 23.7183 2.05164 23.9154 2.09561C27.2048 2.8293 29.1553 6.09043 28.5689 9.32796L25.7138 25.0915C25.4262 26.679 24.5607 28.0774 23.3276 29.027V25.154Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};
export const Numbering = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.83638 8.73934C3.40047 6.34208 4.85692 3.97943 7.23628 3.45453C13.512 2.07006 18.121 2.12943 24.0306 3.44777C26.4075 3.97802 27.8596 6.34043 27.4239 8.73649L24.8068 23.1294C24.4681 24.9918 23.049 26.4871 21.1949 26.8685C16.5288 27.8286 14.7679 27.7664 10.128 26.8437C8.24345 26.469 6.78662 24.9642 6.44288 23.0738L3.83638 8.73934Z"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.3699 9L13.1099 20.3642"
        stroke="#6C6C6C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M18.1621 9L16.9021 20.3642"
        stroke="#6C6C6C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M10.2656 12.792H21.6299"
        stroke="#6C6C6C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M9.62988 16.5842H20.9941"
        stroke="#6C6C6C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Grid = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M11.8799 27.5H19.3799C25.6299 27.5 28.1299 25 28.1299 18.75V11.25C28.1299 5 25.6299 2.5 19.3799 2.5H11.8799C5.62988 2.5 3.12988 5 3.12988 11.25V18.75C3.12988 25 5.62988 27.5 11.8799 27.5Z"
        stroke="#6C6C6C"
        strokeWidth="2.075"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M3.1665 9H28.129"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.1665 16H28.129"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.62988 23H26.6299"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.62988 26V4"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6299 27.4872V2.51221"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6299 26V4"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const Pan = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M5.47151 19.8859C5.86203 20.2765 6.4952 20.2765 6.88572 19.8859C7.27625 19.4954 7.27625 18.8623 6.88572 18.4717L5.47151 19.8859ZM2.00001 15.0002L1.29291 14.2931C0.902381 14.6836 0.902381 15.3168 1.29291 15.7073L2.00001 15.0002ZM6.88572 11.5287C7.27625 11.1382 7.27625 10.505 6.88572 10.1145C6.4952 9.724 5.86203 9.724 5.47151 10.1145L6.88572 11.5287ZM15 16.0003C15.5523 16.0003 16 15.5526 16 15.0003C16 14.448 15.5523 14.0003 15 14.0003L15 16.0003ZM6.88572 18.4717L2.70712 14.2931L1.29291 15.7073L5.47151 19.8859L6.88572 18.4717ZM2.70712 15.7073L6.88572 11.5287L5.47151 10.1145L1.29291 14.2931L2.70712 15.7073ZM2.00001 16.0002L15 16.0003L15 14.0003L2.00002 14.0002L2.00001 16.0002Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M24.6446 10.2304C24.2541 9.8399 23.6209 9.8399 23.2304 10.2304C22.8399 10.6209 22.8399 11.2541 23.2304 11.6446L24.6446 10.2304ZM28 15L28.7071 15.7071C29.0977 15.3166 29.0977 14.6834 28.7071 14.2929L28 15ZM23.2304 18.3554C22.8399 18.7459 22.8399 19.3791 23.2304 19.7696C23.6209 20.1602 24.2541 20.1602 24.6446 19.7696L23.2304 18.3554ZM15 14C14.4477 14 14 14.4477 14 15C14 15.5522 14.4477 16 15 16L15 14ZM23.2304 11.6446L27.2929 15.7071L28.7071 14.2929L24.6446 10.2304L23.2304 11.6446ZM27.2929 14.2929L23.2304 18.3554L24.6446 19.7696L28.7071 15.7071L27.2929 14.2929ZM15 16L28 16L28 14L15 14L15 16Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M19.7695 24.6448C20.16 24.2542 20.16 23.6211 19.7695 23.2305C19.3789 22.84 18.7458 22.84 18.3552 23.2305L19.7695 24.6448ZM14.9999 28.0001L14.2928 28.7072C14.6833 29.0978 15.3164 29.0978 15.707 28.7072L14.9999 28.0001ZM11.6445 23.2305C11.2539 22.84 10.6208 22.84 10.2303 23.2305C9.83973 23.6211 9.83973 24.2542 10.2303 24.6447L11.6445 23.2305ZM16 15C16 14.4477 15.5523 14 15 14C14.4478 14 14 14.4477 14 15L16 15ZM18.3552 23.2305L14.2928 27.293L15.707 28.7072L19.7695 24.6448L18.3552 23.2305ZM15.707 27.293L11.6445 23.2305L10.2303 24.6447L14.2928 28.7072L15.707 27.293ZM14 15L13.9999 28.0001L15.9999 28.0002L16 15L14 15Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M10.1143 5.4715C9.72377 5.86203 9.72377 6.49519 10.1143 6.88572C10.5048 7.27624 11.138 7.27624 11.5285 6.88572L10.1143 5.4715ZM15 2.00001L15.7071 1.2929C15.3166 0.902376 14.6834 0.902376 14.2929 1.2929L15 2.00001ZM18.4715 6.88572C18.862 7.27624 19.4952 7.27624 19.8857 6.88572C20.2762 6.49519 20.2762 5.86203 19.8857 5.47151L18.4715 6.88572ZM14 15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15L14 15ZM11.5285 6.88572L15.7071 2.70711L14.2929 1.2929L10.1143 5.4715L11.5285 6.88572ZM14.2929 2.70711L18.4715 6.88572L19.8857 5.47151L15.7071 1.2929L14.2929 2.70711ZM14 2L14 15L16 15L16 2.00001L14 2Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};
export const Rotate = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M24.1971 5.80951C21.7404 3.35286 18.4741 2 14.9999 2C12.9057 2 10.824 2.50975 8.97991 3.47424C7.91655 4.03033 6.93114 4.73833 6.0577 5.56513V2H4.02539V9.11308H11.1385V7.08077H7.41234C9.43891 5.14627 12.1583 4.03231 14.9999 4.03231C21.0512 4.03231 25.9743 8.95538 25.9743 15.0067C25.9743 15.3437 25.9589 15.6833 25.9286 16.0163L27.9525 16.2006C27.9884 15.8067 28.0066 15.4051 28.0066 15.0069L26.9905 15.0068H28.0066C28.0066 11.5325 26.6537 8.26627 24.1971 5.80951Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M6.45008 21.8879L4.86768 23.1633C5.32738 23.7336 5.83882 24.2689 6.38784 24.7543L7.73394 23.2318C7.27027 22.8218 6.8383 22.3697 6.45008 21.8879Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M4.64632 18.6553L2.72949 19.3308C2.97306 20.0219 3.27801 20.6973 3.636 21.3386L5.41052 20.348C5.10867 19.8073 4.85158 19.2377 4.64632 18.6553Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M4.02547 15.0068H1.99316C1.99316 15.742 2.05515 16.4796 2.17729 17.1989L4.18095 16.8586C4.07775 16.2513 4.02547 15.6283 4.02547 15.0068Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M9.22494 24.3406L8.15381 26.0677C8.77727 26.4544 9.43747 26.7899 10.1159 27.065L10.8795 25.1816C10.3075 24.9498 9.7508 24.6667 9.22494 24.3406Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M25.6044 17.8442C25.445 18.4411 25.2331 19.0286 24.9746 19.5902L26.8207 20.4401C27.1274 19.7738 27.3788 19.0767 27.5679 18.3683L25.6044 17.8442Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M21.4809 23.8643C20.9813 24.2305 20.4477 24.5561 19.895 24.832L20.8028 26.6503C21.458 26.3232 22.0904 25.9373 22.6824 25.5034L21.4809 23.8643Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M24.0581 21.2048C23.7084 21.7147 23.3127 22.1986 22.8818 22.6433L24.3413 24.0576C24.8514 23.5312 25.3201 22.958 25.7342 22.3542L24.0581 21.2048Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M18.1687 25.5171C17.5777 25.6951 16.9665 25.8235 16.3521 25.8989L16.5996 27.9161C17.3284 27.8266 18.0533 27.6742 18.7545 27.4632L18.1687 25.5171Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M12.6523 25.73L12.2197 27.7157C12.9338 27.8713 13.668 27.967 14.4021 28.0002L14.494 25.97C13.8742 25.942 13.2546 25.8611 12.6523 25.73Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};
export const Occ = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 29 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.94131 13.5817C8.9075 14.87 10.4671 15.6343 12.325 15.2917C13.0067 15.166 13.6916 15.0052 14.3314 14.8549C14.6411 14.7822 14.9403 14.7119 15.2235 14.6494C16.1279 14.4494 16.937 14.3098 17.7078 14.3064C18.4367 14.3032 19.1788 14.4194 19.9819 14.5932C20.363 14.6756 20.7473 14.7685 21.1495 14.8658L21.215 14.8816C21.6368 14.9835 22.077 15.0893 22.527 15.1845C24.3783 15.5759 25.9469 14.8437 26.9209 13.5662C27.8693 12.3224 28.2424 10.5938 27.9182 8.89547L26.5606 1.7843C26.4565 1.23867 25.9297 0.880792 25.3841 0.984954C24.8385 1.08911 24.4806 1.61587 24.5848 2.1615L25.9423 9.27267C26.1707 10.469 25.8878 11.6035 25.3213 12.3465C24.7804 13.0559 23.9751 13.4346 22.9431 13.2164C22.525 13.128 22.111 13.0287 21.6876 12.9263L21.6155 12.9089C21.2192 12.8131 20.8129 12.7148 20.4072 12.6271C19.5461 12.4408 18.6405 12.2907 17.6989 12.2949C16.7073 12.2993 15.7284 12.4776 14.7893 12.6852C14.4521 12.7597 14.1262 12.8364 13.8039 12.9122C13.194 13.0556 12.5969 13.1961 11.9602 13.3135C10.9186 13.5056 10.0997 13.107 9.55061 12.3748C8.97841 11.6118 8.69813 10.466 8.92657 9.26935L10.2835 2.1615C10.3876 1.61587 10.0298 1.08912 9.48413 0.984954C8.93851 0.880793 8.41175 1.23867 8.30759 1.7843L6.95069 8.89215C6.62626 10.5916 6.9982 12.3241 7.94131 13.5817Z"
        fill="#2E2E2F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0587 18.3524C20.0925 17.0641 18.5329 16.2998 16.675 16.6424C15.9933 16.7681 15.3084 16.9289 14.6686 17.0792C14.3589 17.1519 14.0597 17.2221 13.7765 17.2847C12.8721 17.4846 12.063 17.6242 11.2922 17.6277C10.5633 17.6309 9.82125 17.5146 9.0181 17.3409C8.63699 17.2585 8.25274 17.1656 7.85046 17.0683L7.78499 17.0525C7.36322 16.9506 6.92302 16.8447 6.47299 16.7496C4.62171 16.3582 3.05313 17.0904 2.07909 18.3679C1.13073 19.6117 0.757598 21.3403 1.08182 23.0386L2.43935 30.1498C2.54352 30.6954 3.07027 31.0533 3.6159 30.9491C4.16152 30.845 4.5194 30.3182 4.41524 29.7726L3.0577 22.6614C2.82932 21.465 3.11216 20.3306 3.67873 19.5875C4.21961 18.8781 5.02493 18.4995 6.0569 18.7177C6.47496 18.8061 6.88897 18.9054 7.31241 19.0078L7.38449 19.0252C7.7808 19.121 8.18708 19.2192 8.59281 19.307C9.45385 19.4933 10.3595 19.6434 11.3011 19.6392C12.2927 19.6348 13.2716 19.4565 14.2107 19.2489C14.5479 19.1743 14.8738 19.0977 15.1961 19.0219C15.806 18.8785 16.4031 18.738 17.0398 18.6206C18.0814 18.4285 18.9003 18.8271 19.4494 19.5593C20.0216 20.3223 20.3019 21.4681 20.0734 22.6647L18.7165 29.7726C18.6124 30.3182 18.9702 30.845 19.5159 30.9491C20.0615 31.0533 20.5882 30.6954 20.6924 30.1498L22.0493 23.0419C22.3737 21.3425 22.0018 19.61 21.0587 18.3524Z"
        fill="#2E2E2F"
      />
      <path
        d="M13.0002 18.5955C13.0002 16.9386 11.881 15.5955 10.5002 15.5955C9.11953 15.5955 8.00024 16.9386 8.00024 18.5955C8.00024 20.2523 9.11953 21.5955 10.5002 21.5955C11.881 21.5955 13.0002 20.2523 13.0002 18.5955Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5002 21.0399C9.42636 21.0399 8.5558 20.1693 8.5558 19.0955C8.5558 18.0216 9.42636 17.151 10.5002 17.151C11.5741 17.151 12.4447 18.0216 12.4447 19.0955C12.4447 20.1693 11.5741 21.0399 10.5002 21.0399ZM7.00024 19.0955C7.00024 21.0285 8.56725 22.5955 10.5002 22.5955C12.4332 22.5955 14.0002 21.0285 14.0002 19.0955C14.0002 17.1625 12.4332 15.5955 10.5002 15.5955C8.56725 15.5955 7.00024 17.1625 7.00024 19.0955Z"
        fill="#2E2E2F"
      />
      <path
        d="M21.0002 13.0955C21.0002 11.7147 19.881 10.5955 18.5002 10.5955C17.1195 10.5955 16.0002 11.7147 16.0002 13.0955C16.0002 14.4762 17.1195 15.5955 18.5002 15.5955C19.881 15.5955 21.0002 14.4762 21.0002 13.0955Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5002 15.0399C17.4264 15.0399 16.5558 14.1693 16.5558 13.0955C16.5558 12.0216 17.4264 11.151 18.5002 11.151C19.5741 11.151 20.4447 12.0216 20.4447 13.0955C20.4447 14.1693 19.5741 15.0399 18.5002 15.0399ZM15.0002 13.0955C15.0002 15.0285 16.5672 16.5955 18.5002 16.5955C20.4332 16.5955 22.0002 15.0285 22.0002 13.0955C22.0002 11.1625 20.4332 9.59546 18.5002 9.59546C16.5672 9.59546 15.0002 11.1625 15.0002 13.0955Z"
        fill="#2E2E2F"
      />
    </svg>
  );
};
export const Tools = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_501_1187)">
        <path
          d="M16.4414 30.967H14.5586C13.0358 30.967 11.7968 29.7281 11.7968 28.2053V27.5684C11.1494 27.3615 10.5204 27.1004 9.91613 26.7877L9.46473 27.2391C8.37143 28.3338 6.62012 28.3017 5.55857 27.2387L4.22785 25.9081C3.16443 24.8458 3.13385 23.0951 4.2282 22.0019L4.67926 21.5508C4.36654 20.9466 4.10551 20.3177 3.89861 19.6702H3.2617C1.73896 19.6702 0.5 18.4313 0.5 16.9085V15.0256C0.5 13.5028 1.73896 12.2639 3.26176 12.2639H3.89867C4.10557 11.6165 4.3666 10.9875 4.67932 10.3832L4.22791 9.93188C3.1342 8.83935 3.16438 7.08845 4.22826 6.02573L5.5591 4.69495C6.62311 3.62948 8.374 3.60288 9.46519 4.6953L9.91619 5.1463C10.5205 4.83364 11.1495 4.57255 11.7969 4.36565V3.72874C11.7969 2.20595 13.0358 0.967041 14.5586 0.967041H16.4414C17.9642 0.967041 19.2031 2.20595 19.2031 3.72874V4.36571C19.8505 4.57255 20.4795 4.83364 21.0838 5.14636L21.5352 4.69495C22.6285 3.6003 24.3798 3.63241 25.4414 4.69536L26.7721 6.02603C27.8355 7.08827 27.8661 8.83899 26.7717 9.93218L26.3207 10.3832C26.6334 10.9875 26.8944 11.6164 27.1013 12.2639H27.7382C29.261 12.2639 30.5 13.5028 30.5 15.0256V16.9085C30.5 18.4313 29.261 19.6702 27.7382 19.6702H27.1013C26.8944 20.3176 26.6334 20.9466 26.3207 21.5508L26.7721 22.0023C27.8658 23.0948 27.8356 24.8457 26.7717 25.9084L25.4409 27.2392C24.3769 28.3047 22.626 28.3313 21.5348 27.2388L21.0838 26.7878C20.4795 27.1005 19.8505 27.3616 19.2031 27.5685V28.2055C19.2031 29.7281 17.9642 30.967 16.4414 30.967ZM10.21 24.9418C11.0495 25.4383 11.953 25.8134 12.8954 26.0566C13.2835 26.1567 13.5547 26.5068 13.5547 26.9076V28.2053C13.5547 28.7589 14.0051 29.2092 14.5586 29.2092H16.4414C16.995 29.2092 17.4454 28.7589 17.4454 28.2053V26.9076C17.4454 26.5068 17.7165 26.1567 18.1047 26.0566C19.0471 25.8134 19.9506 25.4383 20.7901 24.9418C21.1355 24.7376 21.5752 24.7931 21.859 25.0769L22.7782 25.9962C23.1746 26.393 23.811 26.3838 24.1976 25.9966L25.5293 24.665C25.9149 24.2798 25.9278 23.6432 25.5296 23.2456L24.61 22.3259C24.3263 22.0422 24.2707 21.6024 24.4749 21.2571C24.9714 20.4176 25.3464 19.5141 25.5896 18.5716C25.6898 18.1835 26.0398 17.9124 26.4406 17.9124H27.7383C28.2918 17.9124 28.7422 17.4621 28.7422 16.9085V15.0257C28.7422 14.4721 28.2918 14.0218 27.7383 14.0218H26.4406C26.0398 14.0218 25.6898 13.7506 25.5896 13.3625C25.3464 12.4201 24.9713 11.5166 24.4749 10.6771C24.2707 10.3318 24.3263 9.89198 24.61 9.60827L25.5293 8.68899C25.9266 8.29208 25.9163 7.65575 25.5296 7.26956L24.1981 5.93802C23.8121 5.55153 23.1755 5.54022 22.7786 5.93767L21.8591 6.8573C21.5754 7.14106 21.1354 7.19661 20.7901 6.99235C19.9507 6.49589 19.0471 6.12083 18.1047 5.87761C17.7166 5.77747 17.4454 5.42743 17.4454 5.02659V3.72874C17.4454 3.1752 16.995 2.72485 16.4415 2.72485H14.5587C14.0052 2.72485 13.5547 3.1752 13.5547 3.72874V5.02647C13.5547 5.42731 13.2836 5.77735 12.8954 5.87749C11.953 6.12071 11.0495 6.49577 10.21 6.99224C9.86457 7.19644 9.42482 7.14089 9.14111 6.85718L8.22189 5.9379C7.82557 5.5411 7.18906 5.5503 6.80252 5.93749L5.47086 7.26909C5.0852 7.65429 5.0723 8.29079 5.47051 8.68853L6.39014 9.60815C6.67385 9.89187 6.72939 10.3317 6.5252 10.677C6.02873 11.5164 5.65373 12.42 5.41051 13.3624C5.31031 13.7506 4.96027 14.0217 4.55949 14.0217H3.26176C2.70822 14.0217 2.25781 14.4721 2.25781 15.0256V16.9085C2.25781 17.462 2.70822 17.9124 3.26176 17.9124H4.55943C4.96027 17.9124 5.31025 18.1835 5.41045 18.5716C5.65367 19.5141 6.02873 20.4176 6.52514 21.257C6.72934 21.6024 6.67379 22.0422 6.39008 22.3259L5.4708 23.2451C5.07342 23.6421 5.08379 24.2784 5.47045 24.6646L6.80199 25.9961C7.18795 26.3826 7.82451 26.3939 8.22143 25.9965L9.141 25.0768C9.35006 24.8678 9.785 24.6905 10.21 24.9418Z"
          fill="#2E2E2F"
        />
        <path
          d="M15.5 22.4944C11.9008 22.4944 8.97266 19.5662 8.97266 15.967C8.97266 12.3679 11.9008 9.4397 15.5 9.4397C19.0992 9.4397 22.0273 12.3679 22.0273 15.967C22.0273 19.5662 19.0992 22.4944 15.5 22.4944ZM15.5 11.1975C12.87 11.1975 10.7305 13.3371 10.7305 15.967C10.7305 18.597 12.8701 20.7366 15.5 20.7366C18.1299 20.7366 20.2695 18.597 20.2695 15.967C20.2695 13.3371 18.13 11.1975 15.5 11.1975Z"
          fill="#2E2E2F"
        />
      </g>
      <defs>
        <clipPath id="clip0_501_1187">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.5 0.967041)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Arrow = () => {
  return (
    <svg
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.73651 4.21355L4.30002 0.967041H0.693512C0.076355 0.967041 -0.232223 1.71277 0.20493 2.14993L3.53501 5.48C4.06859 6.01359 4.93647 6.01359 5.47005 5.48L6.73651 4.21355Z"
        fill="#292D32"
      />
      <path
        d="M8.30466 0.967041H4.29956L6.73605 4.21355L8.79967 2.14993C9.23039 1.71277 8.92181 0.967041 8.30466 0.967041Z"
        fill="#292D32"
      />
    </svg>
  );
};

export const CloseW = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 5.34166L14.6583 4.16666L9.99999 8.82499L5.34166 4.16666L4.16666 5.34166L8.82499 9.99999L4.16666 14.6583L5.34166 15.8333L9.99999 11.175L14.6583 15.8333L15.8333 14.6583L11.175 9.99999L15.8333 5.34166Z"
        fill="black"
      />
    </svg>
  );
};
export const Close = () => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21.0834C17.5 21.0834 22 16.7709 22 11.5001C22 6.22925 17.5 1.91675 12 1.91675C6.5 1.91675 2 6.22925 2 11.5001C2 16.7709 6.5 21.0834 12 21.0834Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16998 14.212L14.83 8.78784"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.83 14.212L9.16998 8.78784"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Warning = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8333 11.6667H9.16668V7.49999H10.8333M10.8333 15H9.16668V13.3333H10.8333M0.833344 17.5H19.1667L10 1.66666L0.833344 17.5Z"
        fill="#FAAD14"
      />
    </svg>
  );
};
